import React from 'react'
import { connect, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Alert } from './Alert'
import { hideAlert } from '../../states/alerts/actions'
import { IAlertMessage } from './Alert.types'

const StyledAlertManager = styled.div`
  position: fixed;
  z-index: 1000;
  left: 50%;
  transform: translate(-50%, 3rem);
  text-align: center;
`

const HIDE_MESSAGE_TIMEOUT = 5000

interface IAlertManagerProps {
  alertMessages: Array<IAlertMessage>
}

const AlertManager: React.FC<IAlertManagerProps> = ({ alertMessages }) => {
  const dispatch = useDispatch()
  return (
    <StyledAlertManager>
      {alertMessages.map(({ message, type, id }) => (
        <Alert
          key={id}
          type={type}
          onCloseClick={() => dispatch(hideAlert(id))}
          onMounted={() => {
            setTimeout(() => dispatch(hideAlert(id)), HIDE_MESSAGE_TIMEOUT)
          }}
        >
          {message}
        </Alert>
      ))}
    </StyledAlertManager>
  )
}

const EnhancedAlertManager = connect(({ alerts }) => ({
  alertMessages: alerts.list,
}))(AlertManager)

export { EnhancedAlertManager as AlertManager }
